import { render } from "./SchoolTemplateForm.vue?vue&type=template&id=58f19b0a&scoped=true"
import script from "./SchoolTemplateForm.vue?vue&type=script&lang=js"
export * from "./SchoolTemplateForm.vue?vue&type=script&lang=js"

import "./SchoolTemplateForm.vue?vue&type=style&index=0&id=58f19b0a&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58f19b0a"]])

export default __exports__